/* eslint-disable @typescript-eslint/consistent-type-definitions */
import { cva } from 'cva';
export const tabListVariants = cva({
    base: ['@flex'],
    variants: {
        align: {
            'space-between': '@justify-between',
            left: ['@justify-start', '[&>*:nth-last-child(n+2)]:@mr-4', '@flex-wrap'],
        },
    },
    defaultVariants: { align: 'left' }
});
export const listTabVariants = cva({
    base: [
        '@relative',
        '@flex-none',
        '@flex',
        '@items-center',
        '@justify-center',
        '@px-1',
        '@text-grey-5',
        '@bg-transparent',
        'disabled:@cursor-not-allowed',
        'disabled:@text-grey-3-b',
        'data-[state=active]:@text-grey-6',
        'data-[state=active]:after:@absolute',
        'data-[state=active]:after:@bottom-0',
        'data-[state=active]:after:@left-0',
        'data-[state=active]:after:@w-full',
        'data-[state=active]:after:@h-0.5',
        'data-[state=active]:after:@bg-primary',
        'data-[state=active]:after:@rounded-t-sm',
        'data-[state=active]:after:@transition-all',
        'data-[state=active]:after:@duration-200',
        'data-[state=active]:after:@ease-in-out'
    ],
    variants: {
        size: {
            lg: ['@text-t1', '@h-8', 'data-[state=active]:@text-h1', 'data-[state=active]:@font-medium'],
            md: ['@text-t1', '@h-8', 'data-[state=active]:@font-medium'],
            sm: ['@text-caption', '@h-7'],
        },
    },
    defaultVariants: { size: 'lg' }
});
export const listTabInnerVariants = cva({
    base: ['@relative'],
    variants: {
        redDot: {
            true: [
                '@pr-1',
                'after:@absolute',
                'after@top-0',
                'after:@right-[-1px]',
                'after:@w-2',
                'after:@h-2',
                'after:@rounded-md',
                'after:@bg-red1-1',
                'after:@border',
                'after:@border-grey-0',
            ]
        }
    }
});
export const tabButtonListClassName = '@inline-flex @h-8 @rounded @bg-grey-2-a @overflow-hidden';
export const tabButtonClassNames = [
    '@flex @min-w-10 @px-2 @py-1.5  @justify-center @items-center @text-b2 @text-grey-6 @border @border-grey-2_5 @bg-transparent',
    // 最左最右加圆角，第二个以后左边加 -1px 边距接上前一个，倒数第二个以后将左边框设为透明
    '[&:first-child]:@rounded-l [&:last-child]:@rounded-r [&:nth-child(n+2)]:@ml-[-1px] [&:nth-last-child(n+2)]:@border-r-[transparent]',
    // 激活状态，需要下一个元素的左边框设为主题色
    'data-[state=active]:@border data-[state=active]:@border-brand-1-1 data-[state=active]:@bg-brand-1-25 data-[state=active]:@text-brand-1-1 data-[state=active]:@font-medium',
    '[&[data-state=active]+*]:@border-l-brand-1-1',
    // 禁用状态
    'disabled:@bg-grey-2 disabled:@text-grey-4 disabled:@cursor-not-allowed',
];
